export enum INVOICES {
  HEADING = 'Invoices',
}

export const NOTIFICATION_DISMISS_TIME = 5000;
export const fetchPolicy = 'cache-and-network';
